"use client";

// import Notifications from "@/modules/components/notifications/Notifications";
// import Sidebar from "@/modules/components/commons/Sidebar ";
import dynamic from "next/dynamic";

const Sidebar = dynamic(() => import("@/modules/components/commons/Sidebar "), {
  ssr: false,
});

const LayoutWithSidebar = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div className="flex flex-col min-h-screen flex-auto">
      <Sidebar>{children}</Sidebar>
    </div>
  );
};

export default LayoutWithSidebar;
